import store from '../store'
import {closeArchivedTab} from './closeArchivedTab'

export function handleDocArchivedPusher(docId) {
	//remove from state and close tab
	closeArchivedTab(docId)
	store.dispatch({ type: 'ARCHIVE_DOC_SUCCESS', docId})
}